import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import TopicTargetForm from "~/forms/TopicTargetForm";
import topicTargetSchema from "~/forms/TopicTargetForm/topicTargetSchema";
import { TopicActionEnum } from "~/store/topics/types";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const TopicTargetCreateModal = () => {
  const {
    t
  } = useTranslation();
  const status = useSelector(topicSelectors.getTargetStatus);
  const topic = useSelector(topicSelectors.getSelected);
  const action = useSelector(topicSelectors.getAction);
  const error = useSelector(topicSelectors.getTargetError);
  const dispatch = useDispatch();
  const defaultValues = {
    name: "",
    description: "",
    color: "",
    memberIds: [],
    sources: [],
    durationDays: 0,
    durationHours: 8
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    resolver: yupResolver(topicTargetSchema),
    defaultValues
  });
  useEffect(() => {
    if (action === TopicActionEnum.CREATE_TARGET) {
      reset(defaultValues);
    }
  }, [action]);
  const handleClose = () => {
    dispatch(topicActionCreators.actionChanged(null, null));
  };
  const onSubmit = handleSubmit(data => {
    if (topic?.id) {
      data.duration = data.durationDays * 24 + data.durationHours;
      dispatch(topicActionCreators.createTargetStarted(topic.id, data, _ref => {
        let {
          data: newTarget
        } = _ref;
        if (newTarget) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TopicTargetCreateModal.targetCreated", {
              name: newTarget.name
            }),
            timeout: 10000
          }));
        }
      }));
    }
  });
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicTargetCreateModal.createTarget"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true,
    isSticky: true
  }, error), /*#__PURE__*/React.createElement(TopicTargetForm, {
    control: control,
    topic: topic
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicTargetCreateModal.saveTarget")))));
};
export default TopicTargetCreateModal;